import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { gsap } from 'gsap';
import { Canvas } from '@react-three/fiber';
import Scene3D from './components/Scene3D';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WeaponsSection from './components/WeaponsSection';
import GallerySection from './components/GallerySection';
import ContactSection from './components/ContactSection';
import MusicPlayer from './components/MusicPlayer';
import VergilPage from './pages/VergilPage';
import './App.css';

function App() {
  const cursorRef = useRef(null);
  const cursorFollowerRef = useRef(null);

  useEffect(() => {
    // GSAP cursor animation
    const cursor = cursorRef.current;
    const follower = cursorFollowerRef.current;

    const moveCursor = (e) => {
      gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.1
      });
      gsap.to(follower, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.3
      });
    };

    window.addEventListener('mousemove', moveCursor);
    return () => window.removeEventListener('mousemove', moveCursor);
  }, []);

  // Get current page from hash
  const [currentPage, setCurrentPage] = useState(window.location.hash === '#vergil' ? 'vergil' : 'dante');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPage(window.location.hash === '#vergil' ? 'vergil' : 'dante');
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="app">
      {/* Custom Cursor */}
      <div ref={cursorRef} className="cursor"></div>
      <div ref={cursorFollowerRef} className="cursor-follower"></div>

      {/* 3D Background */}
      <div className="canvas-container">
        <Canvas camera={{ position: [0, 0, 5], fov: 75 }}>
          <Scene3D />
        </Canvas>
      </div>

      {/* Main Content */}
      <motion.div 
        className="content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} mobileMenuOpen={mobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
        <MusicPlayer currentCharacter={currentPage} />
        <div className={mobileMenuOpen ? 'page-content hidden' : 'page-content'}>
          {currentPage === 'dante' ? (
            <>
              <HeroSection character="dante" />
              <WeaponsSection />
              <GallerySection />
              <ContactSection theme="dante" />
            </>
          ) : (
            <VergilPage />
          )}
        </div>
      </motion.div>
    </div>
  );
}

export default App;
